<div *ngIf="loaderService.loading$ | async" class="overlay">
  <!-- <img src="../../../../assets/images/loader.gif" /> -->
  <div class="spinner"></div>
  <!--<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>-->
</div>
